module.exports = "/_next/static/images/photoCraigTonks-2bfbd94ed1e0646a09a6ce2e39a14f10.webp";